import { render, staticRenderFns } from "./salesorder.vue?vue&type=template&id=36ee03a6"
import script from "./salesorder.vue?vue&type=script&lang=js"
export * from "./salesorder.vue?vue&type=script&lang=js"
import style0 from "./salesorder.vue?vue&type=style&index=0&id=36ee03a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports